import Console from './Console';
export default function Onboarding() { return <Console />; }
